module.exports = __webpack_public_path__ + "img/bg-section-about-company.4a7054d9.png";